module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-vertical-0e276c7d2312cb51dc0cd7fcf44b2779.svg";